<template>
  <v-container fluid >
    <v-slide-y-transition mode="out-in">
      <v-layout column class="elevation-4">
        <v-tabs centered v-model="activeTab" >
          <v-tab >
            PTO Committees
          </v-tab>
          <v-tab >
            Find PTO Member
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item >
            <pto-committee></pto-committee>
          </v-tab-item>
          <v-tab-item >
            <pto-list></pto-list>
          </v-tab-item>
        </v-tabs-items>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>


<script>
import PTOList from '../components/PTOList.vue';
import PTOByCommittee from '../components/PTOByCommittee.vue';

export default {
  name: 'PTO',
  data () {
    return {
      activeTab: 0
    }
  },
  components : {
    'pto-list': PTOList,
    'pto-committee': PTOByCommittee
    //'students-by-class': StudentsByClass
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
